import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';

import Header from '../../common/header'
import Footer from '../../common/footer'
import SvgIcon from '../../common/svg-icon/svg-icon'
import { Button, Breadcrumb, Input, TextArea, Checkbox, Form, Message } from 'semantic-ui-react'
// import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import './index.scss'

import CareesImg from '../../../assets/images/new-images/careers.jpg';
import { Col, Row } from '../../../components/common'
import axios from 'axios';
import { BASE_URL } from '../../../config/config';
import { emailRegex, apiStatus } from '../../../common/constants';
import { setSaveStatus } from '../../../actions/common/common';
import SEO from '../../../components/seo/SEO';
const ContactUsView = () => {
  const history = useHistory();

  let default_form_data = {
    first_name: '',
    last_name: '',
    company_name: '',
    email: '',
    contact: '',
    comment: '',
  }

  let default_err_data = {
    first_name_error: '',
    last_name_error: '',
    company_name_error: '',
    email_id_error: '',
    email_id_invalid: '',
    contact_error: '',
    comment_error: '',
  }

  const [form_data, setform_data] = useState(default_form_data);
  const [errors, set_errors] = useState(default_err_data);

  const [isFormValid, setisFormValid] = useState('');
  const [services, setServices] = useState([
    { "name": 'services1', "label": "Installation", "checked": false, },
    { "name": 'services2', "label": "Information", "checked": false, },
    { "name": 'services3', "label": "Sales", "checked": false, },
    { "name": 'services4', "label": "Strategy & consulting", "checked": false, },
    { "name": 'services5', "label": "Manufacturing", "checked": false, },
    { "name": 'services6', "label": "Others", "checked": false, },
  ]);

  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');


  const sections = [
    { key: 'Home', content: 'Home', link: true, href: '/' },
    { key: 'contact-us', content: 'Contact Us', link: false },
  ]

  const handleValidation = (field, value) => {
    let error_field = field + '_error';
    setisFormValid(true);
    if (value !== '' && value !== undefined && value !== null && value !== false && value !== true) {
      value = value.replace(/^\s+|\s+$/gm, '')
    }

    if (value === '' || value === undefined || value === null) {
      errors[error_field] = true
      set_errors(errors)
    } else {
      errors[field + '_error'] = false

      if (field == 'email') {
        if (emailRegex.test(value.trim())) {
          errors['email_id_invalid'] = false;
        } else {
          errors['email_id_invalid'] = true;
        }
      }
      set_errors({ ...errors })
    }
  }

  const handleInputChange = (event) => {

    let current_value = event.target.value;

    if (current_value === '' || current_value === undefined || current_value === null) {
      current_value = '';
    }

    form_data[event.target.name] = current_value

    setform_data({ ...form_data });

    // validations 
    handleValidation(event.target.name, current_value);
  }

  const handleServiceChange = (event, index) => {
    console.log('event ', event.target.checked)
    services[index]['checked'] = event.target.checked;
    setServices([...services])
  
  }


  const contact_us_submit = () => {
    console.log('contact us ', services)
    setisFormValid(true)
    for (var error in errors) {
      if (errors[error] === '') {
        errors[error] = true;
        set_errors({ ...errors })
        setisFormValid(false)
      } else {
        if (errors[error] === true) {
          setisFormValid(false)
        }
      }
    }

    setTimeout(() => {
      if (isFormValid) {
        try {

         let  selected_services = services.filter(obj => obj.checked == true)
          let name = form_data.first_name + ' ' + form_data.last_name;
          let payload = {
            "type": "product",
            "document": {
              "name": name,
              "company_name": "",
              "email": form_data.email,
              "contact": form_data.contact,
              "comment": form_data.comment,
              "services": selected_services
            }
          }

          axios.post(`${BASE_URL}/api/v2/mappes/inquiry`, payload).then((response) => {

            const { data, message } = response.data;
            if (data != undefined && message.length > 0) {
              if (message[0]['type'] == 'success') {
                setMessage(message[0]['message'])

                setTimeout(() => {
                  setform_data(default_form_data)
                  set_errors(default_err_data)
                  setErrorMessage('')
                  
                  for(let index in services ){
                    services[index]['checked'] = false
                  }
                  
                  setServices([...services])

                }, 1500);
              } else {
                setErrorMessage('Unable to submit your query, please try again ')
              }
            } else {
              setErrorMessage('Unable to submit your query, please try again ')
            }

          }).finally(() => {
            //  setLoading(false)
          })

        } catch (error) {
          console.log('error ', error)
          setErrorMessage('Unable to submit your query, please try again ')
        }
      }
    }, 300);
  }

  return (
    <>
      <SEO key="contactus-seo"
        robots="index, follow"
        canonicalUrl="/contact-us"
        alternateLink="/contact-us"
        pageType={'contact-us'}

      />
      <Header />
      <div className='contactus-view'>
        <section className='breadcrumb-section'>
          <div className='mappes-container'>
            <Breadcrumb icon={<SvgIcon name='chevron-right' viewbox="0 0 8 14" />} sections={sections} />
          </div>
        </section>
        <section className='banner-section'>
          <div className='mappes-container'>
            <div className='banner-card'>
              <img className='banner-img' src={CareesImg} alt='' />
              <div className='overlay-div'>
                <h2>Got any questions or want to learn more?</h2>
                <p>Reach out to us if you wish to sponsor and advertise on our platform to gain greater visibility</p>
              </div>
            </div>
          </div>
        </section>
        <section className='contactus-section'>
          <div className='mappes-container'>
            <Row>
              <Col lg='5'>
                <div className='address-card'>
                  <h1>Connect with us:</h1>
                  <p>Got any queries regarding the platform or need support in connecting with a supplier or customer? Reach out to us. </p>
                  <ul>
                    <li>
                      <div className='icons'>
                        <SvgIcon name='mail-icon' viewbox="0 0 22 18" />
                      </div>
                      <div className='right-dtl'>
                        <h3>Email</h3>
                        {/* <p>Our friendly team is here to help.</p> */}
                        <p>
                        <a href='mailto:ankit.singhal@mappes.io'>ankit.singhal@mappes.io</a>
                        </p>
                        <a href='mailto:info@mappes.io'>info@mappes.io</a>
                      </div>
                    </li>
                    <li>
                      <div className='icons'>
                        <SvgIcon name='pin-icon' viewbox="0 0 20 24" />
                      </div>
                      <div className='right-dtl'>
                        <h3>Corporate Office</h3>
                       {/*  <p>Come say hello at our office HQ.</p> */}
                        <p>
                          {/* <label>Mappes.io :</label> <br /> */}
                          <label>HQ:</label> 12968 Highland Oaks CT, Fairfax 22033, Virginia USA<br />
                          <label>India Office:</label> B47A Gangotri Enclave Alaknanda New Delhi 110019
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className='icons'>
                        <SvgIcon name='phone-icon' viewbox="0 0 27 26" />
                      </div>
                      <div className='right-dtl'>
                        <h3>Phone</h3>
                        <p>Mon-Fri from 8am to 5pm.</p>
                        <h4> <a href="tel:+91-9650840033"> +91-9650840033</a></h4>
                      </div>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col lg='7'>
                <Form>
                  <div className='signup-card'>
                    <h1>How Can We Assist You In Your Sales/Sourcing Journey?
                    </h1>
                    <p>Fill in your message and our team will get back to you{/*  <a href='mailto:info@mappes.io'>info@mappes.io</a> */}</p>
                    <Row>
                      <Col sm='6' className='mb-3'>
                        <Form.Field className="required">
                          <label className='form-label'>First Name -{errors.first_name_error}-</label>
                          <Input placeholder='Enter first name' name="first_name" id="first_name" onChange={handleInputChange} value={form_data.first_name} />
                          {errors.first_name_error === true ? (<span className='text-danger'> First Name is required </span>) : ''}
                        </Form.Field>
                      </Col>
                      <Col sm='6' className='mb-3'>
                        <Form.Field className="required">
                          <label className='form-label'>Last name</label>
                          <Input placeholder='Enter last name' name="last_name" id="last_name" onChange={handleInputChange} value={form_data.last_name} />
                          {errors.last_name_error === true ? (<span className='text-danger'> Last Name is required </span>) : ''}
                        </Form.Field>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm='6' className='mb-3'>
                        <Form.Field className="required">
                          <label className='form-label'>Email</label>
                          <Input placeholder='you@company.com' name="email" id="email" onChange={handleInputChange} value={form_data.email} />
                          {console.log('errors ', errors)}
                          {errors.email_error === true ? (<span className='text-danger'> Email address is required </span>) : ''}
                          <br />
                          {errors.email_id_invalid === true && errors.email_error !== true ? (<span className='text-danger'> Email address is not valid Email </span>) : ''}
                        </Form.Field>
                      </Col>
                      <Col sm='6' className='mb-3'>
                        <Form.Field className="required">
                          <label className='form-label'>Phone number</label>
                          <Input placeholder='98XXXXX647' name="contact" id="contact" onChange={handleInputChange} value={form_data.contact} />
                          {errors.contact_error === true ? (<span className='text-danger'> Contact is required </span>) : ''}
                        </Form.Field>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm='12' className='mb-3'>
                        <Form.Field className="required">
                          <label className='form-label'>How can we help?</label>
                          <TextArea placeholder='Tell us a little about the project...' rows={3} name="comment" id="comment" onChange={handleInputChange} value={form_data.comment} />
                          {errors.comment_error === true ? (<span className='text-danger'> Comment is required </span>) : ''}
                        </Form.Field>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm='12' className='mb-3'>
                        <label className='form-label'>Services</label>
                        <ul className='services-list'>
                          {
                            services.length > 0 && services.map((service, index) => (
                              <li><Checkbox label={service.label} value={service.label} name={service.name}
                                id={service.name} onChange={(event) => handleServiceChange(event, index)} checked={service.checked} /></li>
                            ))}

                          {/*   <li><Checkbox label='Information' value='Information' name={"services2"}
                            id={'services2'} onChange={handleServiceChange} checked={ } /></li>
                          <li><Checkbox label='Sales' value='Sales' name={"services3"}
                            id={'services3'} onChange={handleServiceChange} checked={ } /></li>
                          <li><Checkbox label='Strategy & consulting' value='value& consulting' name={"services4"}
                            id={'services4'} onChange={handleServiceChange} checked={ } /></li>
                          <li><Checkbox label='Manufacturing' value='Manufacturing' name={"services5"}
                            id={'services5'} onChange={handleServiceChange} checked={ } /></li>
                          <li><Checkbox label='Others' value='Others' name={"services6"}
                            id={'services6'} onChange={handleServiceChange} checked={ } /></li> */}
                        </ul>
                      </Col>
                    </Row>
                    <Button primary className='get-start-btn'
                      onClick={() => contact_us_submit()}>Get Started</Button>

                    {errorMessage != '' ? <span>
                      <div className="text-left mt-2 mb-2">
                        <Message className="reduce-msg-padding" compact visible error content={errorMessage} />
                      </div>
                    </span> : <span></span>
                    }

                    {message != "" &&
                      <span>
                        <div className="text-left mt-2 mb-2">
                          <Message className="reduce-msg-padding" compact visible success content={message} />
                        </div>
                      </span>
                    }

                  </div>
                </Form>
              </Col>
            </Row>
          </div>
        </section>
        <section className='map-section'>
          <div className='mappes-container'>
            <div className='map-heading'>
              <h1>Where You Can Reach Us</h1>
              <p>Get in touch with our local teams for personalized sales and sourcing support and business collaboration.</p>
            </div>
            {/* <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.902123456789!2d-74.006015684594!3d40.712776279331!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a17f4c5c3b3%3A0x7c1e1c1e1c1e1c1e!2sNew%20York%20City%2C%20NY%2C%20USA!5e0!3m2!1sen!2s!4v1631234567890!5m2!1sen!2s"
              allowfullscreen=""
              loading="lazy"> 
              </iframe>
              */}
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d876.3776695435821!2d77.25227941696747!3d28.52436623535478!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce112e885b931%3A0x5b11533ff8ab7fdc!2sGangotri%20Enclave!5e0!3m2!1sen!2sin!4v1754497973462!5m2!1sen!2sin"   allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default ContactUsView